var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMidYMin slice",
    viewBox: "0 0 1440 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bottom_lines)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-590 72.7188L-542 78.0188C-494 83.7188 -398 93.7187 -302 72.7187C-206 51.7187 -110 -2.28125 -14 3.41875C82 8.71875 178 72.7187 274 88.7187C370 104.719 466 72.7187 562 78.0188C658 83.7187 754 125.719 802 147.419L850 168.719V232.719H802C754 232.719 658 232.719 562 232.719C466 232.719 370 232.719 274 232.719C178 232.719 82 232.719 -14 232.719C-110 232.719 -206 232.719 -302 232.719C-398 232.719 -494 232.719 -542 232.719H-590V72.7188Z",
    fill: "url(#paint0_bottom_lines)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 92.3773L40 103.105C80 113.431 160 135.487 240 140.5C320 145.513 400 135.487 480 124.459C560 113.431 640 103.405 720 108.418C800 113.431 880 135.487 960 124.459C1040 113.431 1120 71.3236 1200 65.609C1280 60.2955 1360 92.3773 1400 108.418L1440 124.459V455.022H1400C1360 455.022 1280 455.022 1200 455.022C1120 455.022 1040 455.022 960 455.022C880 455.022 800 455.022 720 455.022C640 455.022 560 455.022 480 455.022C400 455.022 320 455.022 240 455.022C160 455.022 80 455.022 40 455.022H0V92.3773Z",
    fill: "url(#paint1_bottom_lines)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bottom_lines",
    x: -592.948,
    y: 0.051626,
    width: 1445.9,
    height: 235.616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47419
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.233661 0 0 0 0 0.250402 0 0 0 0 0.332796 0 0 0 0.115849 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd",
    x: -13,
    y: 62.022,
    width: 1460,
    height: 410,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.552941 0 0 0 0 0.490196 0 0 0 0 1 0 0 0 0.221345 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.285723 0 0 0 0 0.268443 0 0 0 0 0.665874 0 0 0 0.308375 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_bottom_lines",
    x1: -590,
    y1: 232.719,
    x2: -590,
    y2: 2.99989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_bottom_lines",
    x1: -76.2112,
    y1: 150.354,
    x2: 3.67617,
    y2: -279.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B992FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWaves);
export default __webpack_public_path__ + "static/media/bottom-waves.6096f23d8e8b89a3f2933d049a608a9e.svg";
export { ForwardRef as ReactComponent };